import { useContext, useState } from "react";
import { useParams } from "react-router";
import { fetchData, postData } from "../../../utils/fetch";
import { LanguageContext } from "../../../utils/lang_provider";
import 'react-quill/dist/quill.snow.css';
import TextEditor from "../../../utils/text_editor";
import { Button, Input, message, Flex, Select } from "antd";

export default function CreateContentPage() {
  const { type } = useParams();
  const { language } = useContext(LanguageContext);
  const [ title, setTitle ] = useState("");
  const [ perex, setPerex ] = useState("");
  const [ content, setContent ] = useState("");
  const [ url, setUrl ] = useState("");
  const [ contentLanguage, setContentLanguage ] = useState("sk");

  const createContent = async () => {
    try {
      const userRes = await fetchData(
        `admin/user/${localStorage.getItem("user")}`,
        language
      );

      const newData = {
        title,
        content,
        url,
        language_id: contentLanguage,
        author: userRes.id,
        status: 1,
        perex,
        type: type
      };
      
      const postRes = await postData(
        `admin/content/update/${type}`,
        newData,
        language
      );
      if (postRes.error) {
        throw new Error("Failed to create.");
      }
      
      message.success(`Success.`);
    } catch (error) {
      message.error("Failed to create post.");
    }
  };

  const changeContentLanguage = async (value) => {
    setContentLanguage(value);
  }

  return (
    <Flex vertical style={{margin: "0 5% 0 5%"}}>
      <h1>{`Create ${type}`}</h1>
      <Input
        placeholder="Title"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        style={{ marginBottom: "1rem" }}
      />
      <Input
        placeholder="Link (e.g. my-new-post)"
        value={url}
        onChange={(e) => setUrl(e.target.value)}
        style={{ marginBottom: "1rem" }}
      />
      <Input
        placeholder="Upútavka"
        value={perex}
        onChange={(e) => setPerex(e.target.value)}
        style={{ marginBottom: "1rem" }}
      />
      <TextEditor value={content} setValue={setContent} />
      <Select 
        options={[{value: "sk", label: "SK"}, {value: "en", label: "EN"}]}
        style={{ marginTop: "1rem", width: "200px"}}
        placeholder={"Language"}
        onChange={changeContentLanguage}
      >
      </Select>
      <Button
        className="save-button"
        onClick={createContent}
        type="primary"
        style={{ marginTop: "1rem", width: "200px"}}
      >
        Create
      </Button>
    </Flex>
  );
}
